<template>
  <div id="mobile-nav-container">
    <div v-if="$getSiteId() == 33 || $getSiteId() == 35" id="mobile-nav-alt">
      <div id="learn-btn" class="mobile-nav-item" :class="{ 'nav-green-gradient-bg': routeName == 'Gen2Learn', 'nav-dark-gradient-bg': routeName != 'Gen2Learn' }" @click="goToLearn">
        <div class="row">
          <div class="col w-full">
            <custom-svg variant="home" width="50" height="50"  :color="routeName == 'Gen2Learn' ? 'white' : 'gradient-green'" />
          </div>
        </div>
      </div>
      <div id="status-btn" class="mobile-nav-item" :class="{ 'nav-green-gradient-bg': routeName == 'Gen2Status', 'nav-white-bg': routeName != 'Gen2Status' }" @click="goToStatus">
        <div class="row">
          <div class="col w-full">
            <custom-svg variant="pie-chart-2" width="55" height="55" :color="routeName == 'Gen2Status' ? 'white' : 'gradient-green'" />
          </div>
        </div>
      </div>
      <div id="chat-help-btn" class="mobile-nav-item" :class="{ 'nav-red-gradient-bg': routeName == 'Gen2Support', 'nav-white-bg': routeName != 'Gen2Support' }" @click="goToSupport">
        <div class="row">
          <div class="col w-full">
            <custom-svg v-if="$getSiteId() == 35" variant="help" width="50" height="50" :color="routeName == 'Gen2Support' ? 'white' : 'gradient-red'" />
            <custom-svg v-else variant="help" width="50" height="50" :color="routeName == 'Gen2Support' ? 'white' : 'gradient-orange'" />
          </div>
        </div>
      </div>
      <div id="profile-btn" class="mobile-nav-item" :class="{ 'nav-green-gradient-bg': routeName == 'Gen2StudentProfile', 'nav-white-bg': routeName != 'Gen2StudentProfile' }" @click="goToProfile">
        <div class="row">
          <div class="col w-full">
            <custom-svg variant="user" width="40" height="40" :color="routeName == 'Gen2StudentProfile' ? 'white' : 'gradient-green'" />
          </div>
        </div>
      </div>
      <div id="campus-btn" class="mobile-nav-item" :class="{ 'nav-green-gradient-bg': routeName == 'Gen2Campus', 'nav-white-bg': routeName != 'Gen2Campus' }" @click="goToCampus">
        <div class="row">
          <div class="col w-full">
            <custom-svg variant="campus" width="60" height="60" :color="routeName == 'Gen2Campus' ? 'white' : 'gradient-green'" />
          </div>
        </div>
      </div>
    </div>
    <div v-else id="mobile-nav">
      <div id="learn-btn" class="mobile-nav-item" :class="{ 'nav-redish-gradient-bg': routeName == 'Gen2Learn', 'nav-dark-gradient-bg': routeName != 'Gen2Learn' }" @click="goToLearn">
        <div class="row">
          <div class="col w-full">
            <custom-svg variant="globe" width="43" height="43" color="white" />
          </div>
        </div>
      </div>
      <div id="trade-btn" class="mobile-nav-item" :class="{ 'nav-redish-gradient-bg': routeName == 'Gen2Trade', 'nav-white-bg': routeName != 'Gen2Trade' }" @click="goToTrade">
        <div class="row">
          <div class="col w-full">
            <custom-svg variant="basket" width="43" height="43" :color="routeName == 'Gen2Trade' ? 'white' : 'gradient-dark'" />
          </div>
        </div>
      </div>
      <div id="wallet-btn" class="mobile-nav-item" :class="{ 'nav-redish-gradient-bg': routeName == 'Gen2Wallet', 'nav-white-bg': routeName != 'Gen2Wallet' }" @click="goToWallet">
        <div class="row">
          <div class="col w-full">
            <custom-svg variant="wallet" width="43" height="43" :color="routeName == 'Gen2Wallet' ? 'white' : 'gradient-dark'" />
          </div>
        </div>
      </div>
      <div id="chat-btn" class="mobile-nav-item" :class="{ 'nav-redish-gradient-bg': routeName == 'Gen2Chat', 'nav-white-bg': routeName != 'Gen2Chat' }" @click="goToChat">
        <div class="row">
          <div class="col w-full">
            <custom-svg variant="chat" width="48" height="48" :color="routeName == 'Gen2Chat' ? 'white' : 'gradient-dark'" />
          </div>
        </div>
      </div>
      <div id="menu-btn" class="mobile-nav-item" :class="{ 'nav-redish-gradient-bg': routeName == 'Gen2Menu', 'nav-white-bg': routeName != 'Gen2Menu' }" @click="goToMenu">
        <div class="row">
          <div class="col w-full">
            <custom-svg variant="menu" width="43" height="43" :color="routeName == 'Gen2Menu' ? 'white' : 'gradient-dark'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
export default {
  components: {
    CustomSvg
  },
  props: {
    routeName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  methods: {
    goToLearn() {
      if (this.$route.name != "Gen2Learn") {
        this.$router.push({ name: 'Gen2Learn' });
        this.$emit("changeBackgroundColor", "#000000");
      }
    },
    goToCalendar() {
      if (this.$route.name != "Gen2Calendar") {
        this.$router.push({ name: 'Gen2Calendar' });
        this.$emit("changeBackgroundColor", "#ffffff");
      }
    },
    goToTrade() {
      if (this.$route.name != "Gen2Trade") {
        this.$router.push({ name: 'Gen2Trade' });
        this.$emit("changeBackgroundColor", "#ffffff");
      }
    },
    goToStatus() {
      if (this.$route.name != "Gen2Status") {
        this.$router.push({ name: 'Gen2Status' });
        this.$emit("changeBackgroundColor", "#000000");
      }
    },
    goToWallet() {
      if (this.$route.name != "Gen2Wallet") {
        this.$router.push({ name: 'Gen2Wallet' });
        this.$emit("changeBackgroundColor", "#ffffff");
      }
    },
    goToChat() {
      if (this.$route.name != "Gen2Chat") {
        this.$router.push({ name: 'Gen2Chat' });
        this.$emit("changeBackgroundColor", "#000000");
      }
    },
    goToProfile() {
      if (this.$route.name != "Gen2StudentProfile") {
        this.$router.push({ name: 'Gen2StudentProfile' });
        this.$emit("changeBackgroundColor", "#000000");
      }
    },
    goToMenu() {
      if (this.$route.name != "Gen2Menu") {
        this.$router.push({ name: 'Gen2Menu' });
        this.$emit("changeBackgroundColor", "#ffffff");
      }
    },
    goToCampus() {
      if (this.$route.name != "Gen2Campus") {
        this.$router.push({ name: 'Gen2Campus' });
        this.$emit("changeBackgroundColor", "#000000");
      }
    },
    goToSupport() {
      if (this.$route.name != "Gen2Support") {
        this.$router.push({ name: 'Gen2Support' });
        this.$emit("changeBackgroundColor", "#000000");
      }
    },
  },
  mounted() {
    if (this.$route.name == "Gen2Learn")
      this.$emit("changeBackgroundColor", "#000000");
    else if (this.$route.name == "Gen2Calendar")
      this.$emit("changeBackgroundColor", "#ffffff");
    else if (this.$route.name == "Gen2Trade")
      this.$emit("changeBackgroundColor", "#ffffff");
    else if (this.$route.name == "Gen2Wallet")
      this.$emit("changeBackgroundColor", "#ffffff");
    else if (this.$route.name == "Gen2Chat")
      this.$emit("changeBackgroundColor", "#000000");
    else if (this.$route.name == "Gen2Menu")
      this.$emit("changeBackgroundColor", "#ffffff");
    else {
      this.$emit("changeBackgroundColor", "#000000");
    }
  },
  created() {
    
  }
};
</script>
<style lang="scss">

</style>